import React, { useEffect, useState } from 'react'
import { Box, Button } from '@mui/material'
import FieldConstraintHiddenRouteUI from '../../components/FieldConstraintHiddenRoute'
import { fieldTemplateService } from '../../../../services/fieldTemplateService'
import { useAuthContext } from '../../../../hooks/useAuthContext'
import { FIELD_TYPES } from '../../../../utility/constants'
import { toast } from 'react-toastify'

const DEFAULT_CONSTRAINT = {
  field_template_id: null,
  constraint: null,
  related_field_template_id: null,
  constant_value: null,
  hidden_route_template_id: null,
}

const AdvanceRouteConfiguration = ({ route, processTemplateId }) => {
  const { user } = useAuthContext()
  const [fieldConstraintMap, setFieldConstraintMap] = useState([])
  const [fields, setFields] = useState([])

  const getConstraintFieldActivityId = () => {
    return (
      route?.sourceActivity?.associated_data_entry_activity_template_id || route?.sourceActivity?.id
    )
  }

  useEffect(() => {
    let isActive = true

    ;(async () => {
      const routeTemplateId = route?.route?.route_template_id
      const fieldActivityId = getConstraintFieldActivityId()

      if (!routeTemplateId) {
        if (isActive) {
          setFields([])
          setFieldConstraintMap([])
        }
        return
      }

      const [allFields = [], hiddenRouteMap] = await Promise.all([
        fieldActivityId
          ? fieldTemplateService.getActivityFieldsForAdmin(user, fieldActivityId)
          : Promise.resolve([]),
        fieldTemplateService.getFieldConstraintHiddenRoute(user),
      ])

      if (!isActive) return

      setFields(
        allFields?.filter((it) => it.data_structure != FIELD_TYPES.TABLE && !it.is_subfield) || []
      )

      setFieldConstraintMap(
        hiddenRouteMap?.data?.filter((it) => it.hidden_route_template_id == routeTemplateId) || []
      )
    })()

    return () => {
      isActive = false
    }
  }, [
    route?.route?.route_template_id,
    route?.sourceActivity?.id,
    route?.sourceActivity?.associated_data_entry_activity_template_id,
    user,
  ])

  const addConstraint = async () => {
    setFieldConstraintMap([
      ...fieldConstraintMap,
      {
        id: new Date().getTime(),
        ...DEFAULT_CONSTRAINT,
        hidden_route_template_id: route?.route?.route_template_id,
      },
    ])
  }

  const handleDeleteRow = (constraintId) => {
    setFieldConstraintMap(fieldConstraintMap.filter((it) => it.id != constraintId))
  }

  const saveConstraints = async () => {
    try {
      await fieldTemplateService.addUpdateFieldConstraintHiddenRoute(
        user,
        route?.route?.route_template_id,
        fieldConstraintMap
      )
      toast.success('Updated Route Hidden Configuration!!')
    } catch (error) {
      toast.error('Something went wrong!!')
    }
  }

  return (
    <Box>
      {fields.length > 0 &&
        fieldConstraintMap.map((it) => {
          return (
            <FieldConstraintHiddenRouteUI
              key={it.id}
              fields={fields}
              constraintItem={it}
              updateConstraint={(updated) => {
                setFieldConstraintMap(
                  fieldConstraintMap.map((it) => {
                    return it.id == updated.id ? updated : it
                  })
                )
              }}
              onDelete={handleDeleteRow}
            />
          )
        })}
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16, gap: 16 }}>
        <Button variant="contained" onClick={addConstraint}>
          Add Constraint
        </Button>
        <Button color="primary" variant="contained" onClick={saveConstraints}>
          Save
        </Button>
      </div>
    </Box>
  )
}

export default AdvanceRouteConfiguration
